import * as React from "react"

import styled, { keyframes } from "styled-components"

function Logo(props) {
  return (
    <Icon viewBox="0 0 84.6 9" {...props}>
      <path
        fill="#444242"
        stroke="#fff"
        strokeMiterlimit={10}
        d="M345.3-286.6h308v146h-308z"
      />
      <path d="M0 .2h1l2.8 4.3L6.6.2h1l-3.4 5v3.5h-.8V5.2L0 .2zm10.8 0l3.4 8.6h-.9l-1-2.7H8.4l-1 2.7h-.9L9.9.2h.9zM12 5.4L10.3 1 8.6 5.4H12zM15.9.2l5 7.2V.2h.8v8.6h-.9l-5-7.2v7.2H15V.2h.9zM31 .2l3.2 8.6h-2l-.6-1.9h-3.2l-.7 1.9h-1.9L29 .2h2zm.1 5.3L30 2.3l-1.1 3.1h2.2zM38.6.2c.6 0 1.1.1 1.5.3.5.2.9.4 1.2.8.3.4.6.8.8 1.3.2.5.3 1.1.3 1.9 0 .6-.1 1.2-.2 1.7s-.4 1-.7 1.4c-.3.4-.7.7-1.2.9-.5.2-1.1.3-1.7.3h-3.7V.2h3.7zm-.1 7c.3 0 .5 0 .8-.1.3-.1.5-.3.7-.5.2-.2.4-.5.5-.8.1-.3.2-.7.2-1.2 0-.4 0-.8-.1-1.2-.1-.3-.2-.6-.4-.9-.2-.2-.4-.4-.8-.6-.3-.1-.7-.2-1.2-.2h-1.3v5.4h1.6zm10-7c.4 0 .7.1 1 .2s.6.3.8.5c.2.2.4.5.5.8.1.2.2.5.2.9 0 .5-.1.9-.3 1.3-.2.4-.6.6-1 .8.1.1.3.2.5.3.2.1.3.3.4.5.1.2.2.4.2.6 0 .2.1.4.1.6v1.1c0 .2.1.4.1.5s.1.3.2.4h-1.9c-.1-.3-.2-.6-.2-1S49 7 49 6.6c-.1-.4-.2-.8-.4-1-.2-.2-.5-.3-1-.3h-1.9v3.3h-1.9V.2h4.7zm-.7 3.9c.4 0 .8-.1 1-.3s.3-.5.3-.9-.1-.7-.3-.9-.5-.3-1-.3h-2.1v2.4h2.1zm4.6-1.4c.2-.5.5-1 .8-1.4.4-.4.8-.7 1.3-1s1.2-.3 1.8-.3c.7 0 1.3.1 1.8.3s1 .6 1.3 1c.4.4.6.9.8 1.4.2.5.3 1.1.3 1.8 0 .6-.1 1.2-.3 1.7-.2.5-.5 1-.8 1.4-.4.4-.8.7-1.3.9S57 9 56.3 9s-1.2-.1-1.8-.3-1-.5-1.3-.9c-.4-.4-.6-.9-.8-1.4-.2-.5-.3-1.1-.3-1.7 0-.8.1-1.4.3-2zm1.7 2.9c.1.3.2.6.4.9.2.3.5.5.8.6s.7.2 1.1.2c.4 0 .8-.1 1.1-.2s.5-.4.7-.7.3-.6.4-.9c.1-.3.1-.7.1-1 0-.4 0-.7-.1-1.1s-.2-.7-.4-.9c-.2-.3-.5-.5-.8-.7s-.7-.2-1.1-.2c-.4 0-.8.1-1.1.2s-.5.4-.7.7c-.2.3-.3.6-.4.9s-.1.7-.1 1.1c0 .4.1.7.1 1.1zm9.6 3.2L60.9.2h1.9l1.9 6 1.9-6h1.9l-2.8 8.6h-2zM75.8.2v1.6h-4.5v1.8h4.2v1.5h-4.2v2.1h4.6v1.6h-6.5V.2h6.4zm6 0c.4 0 .7.1 1 .2s.6.3.8.5c.2.2.4.5.5.8.1.3.2.6.2.9 0 .5-.1.9-.3 1.3-.2.4-.6.6-1 .8l.6.3c.2.1.3.3.4.5.1.2.2.4.2.6 0 .2.1.4.1.6v1.1c0 .2.1.4.1.5s.1.3.2.4h-1.9c-.1-.3-.2-.6-.2-1s-.1-.7-.1-1.1c-.1-.4-.2-.8-.4-1-.2-.2-.5-.3-1-.3h-1.9v3.3h-1.9V.2h4.6zm-.7 3.9c.4 0 .8-.1 1-.3s.3-.5.3-.9-.1-.7-.3-.9-.5-.3-1-.3H79v2.4h2.1z" />
    </Icon>
  )
}

const pulse = keyframes`
0% {
  transform: scale(0.7);
  opacity: 0;
  transform-origin: center;
}
50% {
  transform: scale(0.8);
  opacity: 1;
  transform-origin: center;
}
100% {
  transform: scale(0.7);
  opacity: 0;
  transform-origin: center;
}
`;
const Icon = styled.svg`
animation: ${pulse} infinite 4s linear;
    &:hover {
      animation-play-state: paused;
    }
  flex: none;
  transition: fill 0.25s;
  width: 280px;
  @media (min-width: 999px) {
    width: 480px;
  }
`


export default Logo
